import { matchPath, useLocation } from "react-router-dom";

import { getValueFromLinkState } from "seneca-common/utils/routing";

import { linkToJoinClassById } from "features/dashboard/links";
import { linkToAddParentByCode } from "features/dashboard/pages/settings-page/links";
import { linkToParentDashboard } from "features/parents/routes/links";
import useInviteQueryParamsValid from "features/teachers/features/class-sharing/hooks/useInviteQueryParamsValid";

export function useGetHeaderMessage(returningUser: boolean) {
  const location = useLocation();

  const inviteQueryParamsAreValid = useInviteQueryParamsValid(location);
  const actionName = returningUser ? "Login" : "Sign up";

  // teacher invitee
  if (inviteQueryParamsAreValid) {
    return `${actionName} to join this class`;
  }

  // parent
  const redirectAuthUserTo: any = getValueFromLinkState(
    location,
    "redirectAuthenticatedUserToLocation"
  );

  if (!redirectAuthUserTo) {
    return;
  }

  const redirectLink =
    typeof redirectAuthUserTo === "string"
      ? redirectAuthUserTo
      : redirectAuthUserTo.pathname;

  if (
    matchPath(redirectLink, {
      path: linkToParentDashboard()
    })
  ) {
    return `${actionName} to monitor your child's progress`;
  }

  if (
    matchPath(redirectLink, {
      path: linkToJoinClassById()
    })
  ) {
    return `${actionName} to join the class`;
  }

  if (
    matchPath(redirectLink, {
      path: linkToAddParentByCode()
    })
  ) {
    return `${actionName} to link your account to your parent's`;
  }
}
